const NOT_FOUND = {
  IMAGE: {
    DESKTOP: "//static.omuni.com/wildcraft-empty-state.png",
    MOBILE: "//static.omuni.com/wildcraft-empty-state.png",
  },
  TITLE: "404",
  MESSAGE: "Page Not Found",
  STATUS: 404,
};

export default NOT_FOUND;
